import { IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { PrivatePensionContractedTabProps } from '../../../../constants';

export const SecondCopyHeader: React.FC<PrivatePensionContractedTabProps> = ({
  setSelectedTab,
}) => (
  <VStack space={Spacing['stack.xxs']}>
    <HStack alignItems="center">
      <IconButton
        icon="ArrowLeft"
        iconSize="xs"
        iconColor={Color['neutral.black']}
        testId="backButton"
        onPress={() => setSelectedTab('list')}
      />
      <Text variant="semibold" fontSize={Typography['fontsize.lg']}>
        Cobranças - Certificado: 2006220
      </Text>
    </HStack>
    <Text variant="semibold">Envio da(s) cobrança(s) por e-mail</Text>
  </VStack>
);
